module.exports = __webpack_public_path__ + "static/media/belisa_plumilla-webfont.162426d1.woff2";